import {
  Box,
  SignedActor,
  AHText,
  StoreFormattedDate,
  Circle,
  AHIcon,
  AHIconType,
} from "arkh";
import React from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoTimelineFeedback_feedback$key } from "./__generated__/TodoTimelineFeedback_feedback.graphql";
import { FormattedMessage } from "react-intl";
import { LinearGradient } from "expo-linear-gradient";
export function TodoTimelineFeedback(props: {
  feedback: TodoTimelineFeedback_feedback$key;
}) {
  const feedback = useFragment(
    graphql`
      fragment TodoTimelineFeedback_feedback on TodoFeedback {
        title
        body
        createdByActor {
          ...SignedActor_actor
        }
        createdAtDate {
          ...StoreFormattedDate
        }
        contact {
          email
          phoneNumber
          name
        }
      }
    `,
    props.feedback
  );

  return (
    <Box
      style={{
        boxShadow: " 0 4px 25px 0 rgba(0, 0, 0, 0.30)",
        zIndex: 1,
      }}
      cornerRadius="large"
    >
      <Box
        style={{ overflow: "hidden", borderWidth: 1 }}
        borderColor="darkText"
        space="small"
        cornerRadius="large"
      >
        <LinearGradient
          style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
          colors={["#444", "#000"]}
          start={{ y: 0, x: 0 }}
          end={{ y: 1, x: 1 }}
        />
        <Box style={{ flexDirection: "row", alignItems: "center" }}>
          {feedback.createdByActor ? (
            <SignedActor
              signedActor={feedback.createdByActor}
              colorMode="inverted"
            />
          ) : null}
          <AHText
            spaceLeft="small"
            color="text-inverted"
            style={{ flexShrink: 0, overflow: "visible" }}
            numberOfLines={1}
            type="detail"
          >
            <FormattedMessage defaultMessage="Replied" />
          </AHText>
          <Box spaceLeft="small">
            <Circle size="dot" color="status-positive" />
          </Box>

          <AHText
            spaceLeft="small"
            color="text-inverted"
            style={{ flexShrink: 0 }}
            numberOfLines={1}
            type="detail"
          >
            {feedback.createdAtDate ? (
              <StoreFormattedDate date={feedback.createdAtDate} />
            ) : null}
          </AHText>
        </Box>

        <AHText
          spaceTop="small"
          spaceHorizontal="xxsmall"
          type="subtitle"
          color="text-inverted"
        >
          {feedback.title}
        </AHText>
        {feedback.body ? (
          <AHText
            spaceTop="small"
            color="text-inverted"
            spaceHorizontal="xxsmall"
            type="body"
          >
            {feedback.body}
          </AHText>
        ) : null}
        <Box
          style={{ flexDirection: "row", alignItems: "center" }}
          spaceTop="xsmall"
          gap="small"
          spaceLeft="xxsmall"
        >
          {feedback.contact?.name ? (
            <ContactDetail icon="user">{feedback.contact?.name}</ContactDetail>
          ) : null}
          {feedback.contact?.email ? (
            <ContactDetail icon="email">
              {feedback.contact?.email}
            </ContactDetail>
          ) : null}
          {feedback.contact?.phoneNumber ? (
            <ContactDetail icon="phone">
              {feedback.contact?.phoneNumber}
            </ContactDetail>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
}

function ContactDetail(props: {
  children: React.ReactNode;
  icon?: AHIconType;
}) {
  return (
    <Box style={{ opacity: 0.8, alignItems: "baseline", flexDirection: "row" }}>
      {props.icon ? (
        <AHIcon
          type={props.icon}
          size="xxsmall"
          color="text-inverted"
          spaceRight="xxsmall"
        />
      ) : null}
      <AHText color="text-inverted" type="detail">
        {props.children}
      </AHText>
    </Box>
  );
}
